module.exports = "/_next/static/assets/img/sparweltgmbh-5d9affbd6a2c36b21f8054523256035f.jpg";